import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import './History.css'

const VideoDetails = () => {
  const { state } = useLocation(); // Get data passed from HistoryList
  const navigate = useNavigate();

  if (!state || !state.video) {
    navigate('/'); // Redirect to history if no data is found
    return null;
  }

  const { video_title, video_id, analysis_result } = state.video;

  return (
    <div className='analysis-result'>
      <button onClick={() => navigate('/history')} style={{ marginBottom: '20px' }}>
        Back to History
      </button>
      <h1>{video_title}</h1>
      <div>
        {/* Replace with your video embed URL */}
        <iframe
          // width="560"
          // height="315"
          className='responsive-iframe'
          src={`https://www.youtube.com/embed/${video_id}`}
          title={video_title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className='analysis-result-text'>
        <h2>Analysis Result</h2>
        <ReactMarkdown>{analysis_result}</ReactMarkdown>
      </div>
    </div>
  );
};

export default VideoDetails;
